import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const Loading = () => (
  <div className="flex h-screen items-center justify-center bg-slate-50">
    <Loader2 className="h-8 w-8 animate-spin text-amber-600" />
  </div>
);

export const ProtectedRoute = ({ children, roles }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return children;
};
